import formTypes from './FormTypes'

const redirectLocations = {
    ...formTypes,
    PREVIOUS: "previous",
    CUSTOM: "custom"
};

export default redirectLocations;
